import { injectCpmsBoChargePointDiagnosticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-charge-point-diagnostics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoChargePointDiagnosticsApi =
  injectCpmsBoChargePointDiagnosticsApi(baseApi);

export const {
  useCpmsBoDownloadChargePointDiagnosticQuery,
  useLazyCpmsBoDownloadChargePointDiagnosticQuery,
  useCpmsBoGetDiagnosticsPaginatedQuery,
} = cpmsBoChargePointDiagnosticsApi;
